module.exports = __webpack_public_path__ + "static/media/password.494be13a.svg";